export const ActivateCoreFlags = {
  Auth0VerificationFlowTracing:
    'squad-activate-core.auth0-verification-flow-tracing',
  MaintenanceMode: 'maintenance-mode',
  StagingPermittedDomains: 'activate.stagingPermittedDomains',
  UseRedirectServiceV1: 'api-platform-squad.use-redirect-service-v1',
  SAMLGraphql: 'squad-api-platform.saml-graphql',
  Auth0AccessToken: 'squad-api-platform.auth0-access-token',
  Auth0ConsolidateAuthTokenStorage:
    'squad-api-platform.consolidate-auth-token-storage',
  Auth0RefreshToken: 'squad-api-platform.auth0-refresh-token',
  FixAuth0UserSessions: 'squad-api-platform.fix-auth0-user-sessions',
  EssensysDisable: 'squad-api-platform.essensys-integration.disable',
  DisableWhitelabelOAuthConfig:
    'squad-api-platform.disable-whitelabel-oauthconfig',
  PrismaMigrationRemoveUserIntegrationResolver:
    'pavel.prisma-migration-remove-user-integration-resolver',
  ChannelManagementGoLive: 'foundations.channel-management-go-live',
  MultifamilyCreateProperty: 'multifamily.create-property',
  IntuitiveUserManagement: 'multifamily.intuitive-user-management',
  AddManualResidents: 'multifamily.add-manual-residents',
  MessagingAndMarketplace: 'multifamily.messaging-and-marketplace',
  MediaUploadV2: 'multifamily.media-upload-v2',
  UrgentCommunicationMessage: 'multifamily.urgent-communications-message',
  RelayUI: 'squad-relay-and-beacon.relay-UI',
  PushNotificationPermissionModal:
    'squad-activate-core.show-push-notification-permission-modal',
  PrismaMigrationRequestPhoneNumberVerificationResolver:
    'pavel.prisma-migration-request-phone-number-verification-resolver',
  PrismaMigrationVerifyEmailOnBehalfOfUserResolver:
    'pavel.prisma-migration-verify-email-on-behalf-of-user-resolver',
  PrismaMigrationRequestAccountDeletionResolver:
    'pavel.prisma-migration-request-account-deletion-resolver',
  CoreTouchContentLightweightResponse:
    'squad-core.touch-content.lightweight-response',
  NotificationsPerformanceUsersMultiQuery:
    'activate-core.notifications-performance.users-multi-query',
  EnableOAuthAuth0UserDetection:
    'squad-activate-core.enable-oauth-auth0-user-detection',
  UseOIDCConnectionParameter:
    'squad-activate-core.use-oidc-connection-parameter',
  MobileClearSessionWhenExpiredRedirect:
    'squad-activate-core.mobile-clear-session-when-expired-redirect',
  MixpanelEnabled: 'squad-activate-core.mixpanel-enabled',

  // Rogue flags
  ActivatePlatformCoreActivateRebrand:
    'activate-platform-core.activate-rebrand',
  ActivatePlatformCoreHidePendoWidget:
    'activate-platform-core.hide-pendo-widget',
  ActivatePlatformCoreHideZendeskWidget:
    'activate-platform-core.hide-zendesk-widget',
  ActivatePlatformCoreKoaCompression: 'activate-platform-core.koa-compression',
  ActivatePlatformCoreShowWhitelabelNameInSms:
    'activate-platform-core.show-whitelabel-name-in-sms',
  ApiPlatformDisableEssensysSchronization:
    'api-platform.disable-essensys-schronization',
  ApiPlatformDisableStudioCustomOnboarding:
    'api-platform.disable-studio-custom-onboarding',
  OtherIntegrationsOneWaySyncCalendarIntegrationTest:
    'other-integrations.one-way-sync-calendar-integration-test',
  OtherIntegrationsRiseActivateViabilityPoc:
    'other-integrations.rise-activate-viability-poc',
  SquadApiPlatformActivateTokenManager:
    'squad-api-platform.activate-token-manager',
  SquadApiPlatformAuth0EnableOidcWebviewScene:
    'squad-api-platform.auth0-enable-oidc-webview-scene',
  SquadApiPlatformAuth0RedirectIos184:
    'squad-api-platform.auth0-redirect-ios-18-4',
  SquadApiPlatformAuthenticateMiddlewareLib:
    'squad-api-platform.authenticate-middleware-lib',
  SquadApiPlatformOidcV2: 'squad-api-platform.oidc-v2',
  SquadApiPlatformRequirePresenceOfAcmSession:
    'squad-api-platform.require-presence-of-acm-session',
  UsersServiceUseNewUserService: 'users-service.use-new-user-service',
  CoreApiPlatformActivateSessionExpire:
    'core-api-platform.activate-session-expire',
  CoreApiClearSessionCallback: 'core-api.clear-session-callback',
  MultifamilyParcelManagement: 'multifamily.parcel-management',
  MultifamilyResidentDetails: 'multifamily.resident-details',
  MultifamilyUnitFloors: 'multifamily.unit-floors',
  FastContentQuery:
    'activate-core-experience-content-query-optimization-resolver',
  // Rogue flags end
} as const;
